import { Paper, Typography, Box, Chip } from '@mui/material';
import { QuestionAnswer, AccessTime } from '@mui/icons-material';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import 'dayjs/locale/ko';
import type { Inquiry } from '../../../../services/inquiryService';

dayjs.extend(relativeTime);
dayjs.locale('ko');

interface Props {
  inquiries: Inquiry[];
  loading?: boolean;
}

const PendingInquiriesWidget = ({ inquiries, loading }: Props) => {
  const pending = inquiries.filter((i) => i.status === 'pending').slice(0, 5);

  return (
    <Paper elevation={0} sx={{
      p: { xs: 2, md: 3 }, borderRadius: 3,
      border: '1px solid #e5e7eb', height: '100%',
      display: 'flex', flexDirection: 'column',
    }}>
      <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
        <Typography fontWeight={700} sx={{ fontSize: '0.95rem', color: '#0f172a' }}>
          미처리 문의
        </Typography>
        {pending.length > 0 && (
          <Chip
            label={pending.length}
            size="small"
            sx={{ fontWeight: 700, bgcolor: '#fef2f2', color: '#dc2626', height: 22, fontSize: '0.75rem' }}
          />
        )}
      </Box>

      <Box sx={{ flex: 1 }}>
        {loading ? (
          <Typography color="text.secondary" fontSize="0.85rem">불러오는 중...</Typography>
        ) : pending.length === 0 ? (
          <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" sx={{ py: 4 }}>
            <QuestionAnswer sx={{ fontSize: 36, color: '#e2e8f0', mb: 1 }} />
            <Typography sx={{ fontSize: '0.82rem', color: '#94a3b8' }}>미처리 문의가 없습니다</Typography>
          </Box>
        ) : (
          <Box display="flex" flexDirection="column" gap={1.5}>
            {pending.map((inq) => (
              <Box key={inq.id} sx={{
                p: 1.5, borderRadius: 2, bgcolor: '#fafbfc',
                border: '1px solid #f0f0f0',
                transition: 'all 0.12s',
                '&:hover': { bgcolor: '#f0f9ff', borderColor: '#bfdbfe' },
              }}>
                <Box display="flex" alignItems="center" justifyContent="space-between" mb={0.5}>
                  <Typography sx={{ fontWeight: 600, fontSize: '0.82rem', color: '#0f172a' }}>
                    {inq.name}
                  </Typography>
                  <Chip
                    label={inq.type}
                    size="small"
                    sx={{ height: 20, fontSize: '0.65rem', fontWeight: 600, bgcolor: '#f1f5f9', color: '#64748b' }}
                  />
                </Box>
                <Typography sx={{
                  fontSize: '0.78rem', color: '#64748b',
                  overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                }}>
                  {inq.subject}
                </Typography>
                <Box display="flex" alignItems="center" gap={0.4} mt={0.5}>
                  <AccessTime sx={{ fontSize: 12, color: '#94a3b8' }} />
                  <Typography sx={{ fontSize: '0.68rem', color: '#94a3b8' }}>
                    {inq.created_at?.toDate ? dayjs(inq.created_at.toDate()).fromNow() : '-'}
                  </Typography>
                </Box>
              </Box>
            ))}
          </Box>
        )}
      </Box>
    </Paper>
  );
};

export default PendingInquiriesWidget;
